var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "23px",
    viewBox: "0 0 24 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "B2D881BD-B49C-4EC9-8750-0DB546DE6353@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop---My-Information",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Contact",
    transform: "translate(-302.000000, -1884.000000)",
    fill: "#FFFFFE"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(269.000000, 1700.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Input-/-Primary-/-Default-Copy",
    transform: "translate(20.000000, 148.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.975,59 L13.975,44 L18.975,44 L18.975,59 L13.975,59 Z M16.7391956,41.5366148 C15.2113672,41.5366148 13.975,40.2960965 13.975,38.7676367 C13.975,37.2405183 15.2113672,36 16.7391956,36 C18.2632302,36 19.5016059,37.2405183 19.5016059,38.7676367 C19.5016059,40.2960965 18.2632302,41.5366148 16.7391956,41.5366148 Z M36.975,59 L32.2116389,59 L32.2116389,51.5287222 C32.2116389,49.7471958 32.1790559,47.4555121 29.7346643,47.4555121 C27.2545653,47.4555121 26.8738356,49.3962112 26.8738356,51.3999533 L26.8738356,59 L22.1113672,59 L22.1113672,43.63671 L26.6830245,43.63671 L26.6830245,45.735911 L26.7468513,45.735911 C27.383335,44.5282557 28.9381671,43.2548745 31.2571366,43.2548745 C36.0838783,43.2548745 36.975,46.4369861 36.975,50.5732392 L36.975,59 Z",
    id: "Path-3"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.701f55938693c25a7ee180853093fb1d.svg";
export { ForwardRef as ReactComponent };